import React from "react";
import { Switch, Route } from "react-router-dom";
import Authorization from "../../components/Authorization";
import BookingHistoryRouter from "./BookingHistory";
import PTORouter from "./PTO";

const PayMgmnt = Authorization(["ADMIN", "HR", "PTO"]);

const PTOProcessingRouter = () => (
  <Switch>
    <Route path="/pto/pto-request">{PayMgmnt(PTORouter)}</Route>
    <Route path="/pto/booking-history">{PayMgmnt(BookingHistoryRouter)}</Route>
  </Switch>
);

export default PTOProcessingRouter;
